/* eslint-disable */
export default {
	getDateTime: function (date, format) {
		if (process.env['NODE_ENV'] == 'development') {
			console.warn(`dateTime.getDateTime - This function is deprecated, please use Date.formatString instead`);
		}

		var myDate;
		var myFormat;
		var result = '';

		if (!date) {
			myDate = new Date();
		} else {
			myDate = new Date(date);
		}

		if (!format) {
			myFormat = 'dd/MM/yyyy HH:mm'
		} else {
			myFormat = format;
		}

		myFormat = myFormat.replace('dd', this.padNumber(myDate.getDate()));
		myFormat = myFormat.replace('MM', this.padNumber(myDate.getMonth() + 1));
		myFormat = myFormat.replace('yyyy', this.padNumber(myDate.getFullYear()));
		myFormat = myFormat.replace('yy', this.padNumber(myDate.getFullYear().toString().substring(2)));

		myFormat = myFormat.replace('HH', this.padNumber(myDate.getHours()));
		myFormat = myFormat.replace('mm', this.padNumber(myDate.getMinutes()));
		myFormat = myFormat.replace('ss', this.padNumber(myDate.getSeconds()));

		myFormat = myFormat.replace('ddd', this.padNumber(myDate.getDay()));

		return myFormat;
		// return result;
	},
	getDateTimeDifference: function (d1, d2) {
		if (process.env['NODE_ENV'] == 'development') {
			console.warn(`dateTime.getDateTimeDifference - This function is deprecated, please use Date.getDifference instead`);
		}

		var diff = d1.getTime() - d2.getTime();

		var totalSec = diff / 1000;
		var totalHour = totalSec / 60 / 60;
		var totalMin = (totalHour - Math.floor(totalHour)) * 60;
		var totalSec = (totalMin - Math.floor(totalMin)) * 60;
		
		return {
			time: `${this.padNumber(Math.floor(totalHour))}:${this.padNumber(Math.round(totalSec) == 60 ? Math.floor(totalMin) + 1 : Math.floor(totalMin))}:${this.padNumber(Math.round(totalSec) == 60 ? 0 : Math.round(totalSec))}`,
			hour: Math.floor(totalHour),
			min: Math.round(totalSec) == 60 ? Math.floor(totalMin) + 1 : Math.floor(totalMin),
			secs: Math.round(totalSec) == 60 ? 0 : Math.round(totalSec),
			totalSec: diff
		};
	},
	getDateTimeDifferenceByDay: function(d1, d2) {
		if (process.env['NODE_ENV'] == 'development') {
			console.warn(`dateTime.getDateTimeDifferenceByDay - This function is deprecated, please use Date.getDifference instead`);
		}

		if (Date.parse(d1) && Date.parse(d2)) {
			d1.setHours(0, 0, 0, 0);
			d2.setHours(0, 0, 0, 0);
			
			let diff = d2.getTime() - d1.getTime();
			return diff / 1000 / 60 / 60 / 24;
		} else {
			return null;
		}
	},
	stringToDate: function(str, splitter) {
		if (process.env['NODE_ENV'] == 'development') {
			console.warn(`dateTime.stringToDate - This function is deprecated, please use String.toDate instead`);
		}

		var split = str.split(splitter);
		var date = `${split[1]}-${split[0]}-${split[2]}`;

		return new Date(date);
	},
	getDate: function(str, format) {
		if (!str || !format) {
			console.error('date and format is compulsory');
			return null;
		}

		var yearIndex = format.indexOf('yyyy');
		var monthIndex = format.indexOf('MM');
		var dayIndex = format.indexOf('dd');
		var hourIndex = format.indexOf('HH');
		var minIndex = format.indexOf('mm');

		var year = parseInt(str.substring(yearIndex, yearIndex + 4));
		var month = parseInt(str.substring(monthIndex, monthIndex + 2));
		var day = parseInt(str.substring(dayIndex, dayIndex + 2));
		var hour = parseInt(str.substring(hourIndex, hourIndex + 2));
		var min = parseInt(str.substring(minIndex, minIndex + 2));

		return new Date(year, month - 1, day, hour, min);
	},
	padNumber: function (number) {
		var result = '';

		if (number < 10) {
			result += '0';
			result += number;
		} else {
			result = number;
		}

		return result;
	}
}